/**
 * Copyright 2019 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import Image from '@/components/NextImage';
import { getPriceArray } from '../../utils/getPriceArray';
import { useLabels } from '@/hooks/useLabels';
import Price from '@/components/AZCustomComponent/Price';
import type { SkuDetails } from '../../../interface';
import styles from './stylesV2.module.scss';

export type ParentSkuCardProps = {
  skuDetails: SkuDetails;
  skuPrice?: string | number | string[] | number[];
  skuRetailPrice: string | number | string[] | number[];
  skuQuantity: number | string;
};

const labelMap = {
  label_deal_bundle_parent_sku_quantity: 'label_deal_bundle_parent_sku_quantity',
  label_deals_sku_location: 'label_deals_sku_location',
};

export const ParentSkuCard = ({
  skuDetails,
  skuQuantity,
  skuPrice,
  skuRetailPrice,
}: ParentSkuCardProps) => {
  const labels = useLabels(labelMap);
  const { productImageUrl, description, locationFilter } = skuDetails;

  return (
    <article className={styles.parentSkuCard}>
      <Image
        src={productImageUrl}
        width={40}
        height={40}
        className={styles.parentSkuImage}
        alt={description}
      />
      <div className={styles.parentSkuDescription}>
        <div className={styles.description}> {description} </div>
        {Boolean(locationFilter) && (
          <div className={styles.locationSection}>
            <span className={styles.locationLabel}>{labels.label_deals_sku_location}</span>
            <span className={styles.locationValue}>{` ${locationFilter}`}</span>
          </div>
        )}
      </div>
      <div className={styles.priceAndQty}>
        <div className={styles.parentSkuQuantity}>
          <span className={styles.parentSkuQuantityLabel}>
            {labels.label_deal_bundle_parent_sku_quantity}
          </span>{' '}
          <span className={styles.parentSkuQuantityValue}>{skuQuantity}</span>
        </div>
        {skuPrice ? (
          <Price
            priceType="small"
            dealPrice={getPriceArray(skuPrice)}
            wasDealPrice={getPriceArray(skuRetailPrice)}
            each={+skuQuantity > 1}
            className={styles.price}
            priceClassName={styles.priceDollars}
            centsClassName={styles.priceCents}
          />
        ) : (
          <Price
            priceType="small"
            dealPrice={getPriceArray(skuRetailPrice)}
            each={+skuQuantity > 1}
            className={styles.price}
            priceClassName={styles.priceDollars}
            centsClassName={styles.priceCents}
          />
        )}
      </div>
    </article>
  );
};
